import type { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { iconSize } from '@guardian/source-foundations';
import type { IconProps } from './types';

export const SvgAlert = ({ size }: IconProps): EmotionJSX.Element => {
	return (
		<svg
			viewBox="0 0 30 30"
			xmlns="http://www.w3.org/2000/svg"
			width={size ? iconSize[size] : undefined}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.3 7.775L14.025 17.25H16.025L16.775 7.775L16.05 7H14.025L13.3 7.775ZM17 21.25C17 20.15 16.1 19.25 14.975 19.25C13.9 19.25 13 20.15 13 21.25C13 22.3249 13.9 23.2249 14.975 23.2249C16.075 23.2249 17 22.3249 17 21.25Z"
			/>
		</svg>
	);
};
